import { api } from '../api';

export const reportService = {
  async fetchArticles(params, cancelToken) {
    return api.get('reports/articles', { params, cancelToken: cancelToken.token });
  },

  async fetchArticle(id) {
    return api.get('reports/articles/' + id );
  },

  async fetchArticlePages(id, params) {
    return api.get('reports/articles/' + id  + '/pages', { params });
  },

  async fetchPages(params) {
    return api.get('reports/pages', { params });
  },

  async fetchPage(id, params) {
    return api.get('reports/pages/' + id, { params });
  },
};